import { Component, Mixins, Prop } from 'vue-property-decorator'
import { DateMixin } from '@kwixeo/interface-vue'

@Component
export default class LotUsed extends Mixins(DateMixin) {
  @Prop({ required: true }) value!: KwixeoCatalog.UsedLots
}
